




















import { defineComponent, ref } from "@vue/composition-api";
import { isMobile } from "@/lib/browserUtils";
import BaseIconButton from "@/components/BaseIconButton";
import InputRange from "@/components/BaseInputs/InputRange";

export default defineComponent({
  name: "VolumeInput",
  components: { InputRange, BaseIconButton },
  props: {
    value: { type: Number, default: 0 },
    muted: { type: Boolean, default: false },
  },
  setup() {
    const show = ref(false);
    const customStyle = ref({});

    const toggleShow = () => {
      if (isMobile()) return;
      show.value = !show.value;
    };

    const onEnter = (el: HTMLElement) => {
      const { top } = el.getBoundingClientRect();
      const offset = 16;
      const newValue = top < offset ? "86px" : "-62px";
      if (newValue) el.style.setProperty("--top-position", newValue);
    };

    const onAfterLeave = (el: HTMLElement) => {
      el.style.setProperty("--top-position", "-62px");
    };

    return {
      show,
      customStyle,
      toggleShow,
      onEnter,
      onAfterLeave,
    };
  },
});
